import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { IconsEnum } from '@enums/icons.enum';
import { NotificationMessagesService } from '@modules/notification-messages/services/notification-messages.service';
import { NotificationsService } from '@services/notifications.service';
import { EventConstant } from '../../../../sse/event.constant';
import { SignalrService } from '../../../../sse/signalr.service';
import { filter, switchMap, takeUntil, } from 'rxjs/operators';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButtonModule, MatIconModule, RouterLink],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  protected notificationsCount = 0;
  private subscriptions: Subscription[] = [];
  protected readonly IconsEnum = IconsEnum;
  private destroy$ = new Subject<void>();


  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly notificationsService: NotificationsService,
    private readonly notificationMessagesService: NotificationMessagesService,
    private readonly signalrService: SignalrService
  ) {}

  ngOnInit(): void {
    this.recountNotificationsWatcher();
    this.notificationCounterEventChange();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private notificationCounterEventChange(): void {
    this.signalrService.sseEventListener(EventConstant.notificationsUpdateEvent);

    this.signalrService.eventDataChange.pipe(
      filter((value) => value.eventName === EventConstant.notificationsUpdateEvent),
      switchMap(() => this.notificationsService.getUnreadNotificationsCount()),
      takeUntil(this.destroy$)
    ).subscribe((response) => this.notificationMessagesService.recountNotificationsEvent.next(response));
  }

  private recountNotificationsWatcher(): void {
    const recountNotificationsEventSubs = this.notificationMessagesService.recountNotificationsEvent.subscribe((count): void => {
      this.notificationsCount = count;

      this.changeDetectorRef.markForCheck();
    });

    this.subscriptions.push(recountNotificationsEventSubs);
  }
}
